// Encoding:
// <marker (1 byte)><length (4 bytes)>
// marker when all numbers < 2^8 - 1: 0x31
// marker when all numbers < 2^16 - 1: 0x32
// marker when all numbers < 2^32 - 1: 0x34
// So [1, 2, 3, 4] is 0x310401020304

import { encodeNumber } from "./encodeNumber";
import { NUMBER_ARRAY_MARKER_BY_WIDTH } from "./markers";

export type WIDTH = 1 | 2 | 4;

export const NULL_VALUE_BY_WIDTH = {
  1: 0xff,
  2: 0xffff,
  4: 0xffffffff,
};

const SETTER_BY_WIDTH = {
  1: "setUint8",
  2: "setUint16",
  4: "setUint32",
} as const;

export function encodeNumberArray(array: (number | null)[]): Uint8Array {
  const maxValue = array.reduce(
    (acc: number, value) => Math.max(acc, value ?? 0),
    0,
  );
  // The value (2^width - 1) is reserved for the null value,
  // so we use < 255 instead of < 256
  const width = maxValue < 255 ? 1 : maxValue < 65535 ? 2 : 4;
  const nullValue = NULL_VALUE_BY_WIDTH[width];
  const setter = SETTER_BY_WIDTH[width];
  const header = new Uint8Array([
    NUMBER_ARRAY_MARKER_BY_WIDTH[width],
    ...encodeNumber(array.length),
  ]);
  const contents = new Uint8Array(array.length * width);
  const contentsView = new DataView(contents.buffer);

  array.forEach((value, index) => {
    contentsView[setter](index * width, value ?? nullValue);
  });

  return new Uint8Array([...header, ...contents]);
}
